module.exports = __webpack_public_path__ + "img/EVC-system.74815e61.png";